import React from 'react';
import './AdminSidebar.css';

function AdminSidebar({ activeTab, onTabChange, menuItems, roleColor, isMobileOpen, onMobileClose }) {
  return (
    <>
      {/* Mobile Overlay */}
      {isMobileOpen && (
        <div className="sidebar-mobile-overlay" onClick={onMobileClose} />
      )}

      {/* Sidebar */}
      <aside className={`admin-sidebar ${isMobileOpen ? 'mobile-open' : ''}`}>
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
              onClick={() => {
                onTabChange(item.id);
                onMobileClose?.();
              }}
              title={item.label}
              style={activeTab === item.id ? { borderLeftColor: roleColor } : {}}
            >
              <span className="nav-icon">
                {item.icon}
              </span>
              <span className="nav-label">{item.label}</span>
              {item.badge && (
                <span className="nav-badge">{item.badge}</span>
              )}
            </button>
          ))}
        </nav>
      </aside>
    </>
  );
}

export default AdminSidebar;
